export default "__VITE_ASSET__DhcddEgP__"